var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('phone-calls-vue',{attrs:{"id":_vm.employeeId}}),_c('appointment-result-vue',{attrs:{"id":_vm.employeeId}}),_c('week-overall-vue',{attrs:{"id":_vm.employeeId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }